import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import classNames from "classnames";
import { MuiThemeProvider, withStyles,Grid, createTheme, CircularProgress } from '@material-ui/core'
import Routers from './Routers';
import { withTranslation } from 'react-i18next';
import defaultTheme from './release/theme.css'
import Header from './release/components/Header';
import { setGlobalHistory, portalCfg } from './portal.router.config'
import { setT } from './release/utils/translateUtil'
import { getData, setAppCfg, saveDataIntoAsyncStore, clearSession, getLanguage, getAppCfg, setRejectTriggerContact, setSupportOrderLocation, setSupportOrderContact, setOrderConfig, setPortalConfigV2 } from './release/utils/common';
import crmServices from './release/wsclient/crmservices'
import i18n from './release/translations/i18n'
import ModalAlert from './release/components/ModalAlert'
import t from './release/utils/translateUtil';
import Loading from './release/components/Loading'
import { logOut } from './release/utils/common'
import Transactions from './release/pages/transactions/Transactions';
import ReferFriend from './release/pages/refer-friend/ReferFriend';
import { isRetina } from './release/utils/util';
import MyProfile from './release/pages/my-profile/MyProfile';
import MoreInfo from './release/pages/more-info/MoreInfo';
import MyAccount from './release/pages/my-account/MyAccount';
import Notifications from './release/pages/notifications/Notifications';
import OrderHistoryController from './release/pages/orders/OrderHistoryController';
import SettingsController from './release/pages/settings/SettingsController';
import { portal_config, connection, domainName } from './portal.config';
import { custom_assets } from './portal.config';
import Geocode from "react-geocode";
import { dataUtil, usage_type } from './release/wsclient/crmservices/dataUtil';
import { custom_theme } from './portal.custom.page.config';
import Addresses from './release/pages/addresses/Addresses';
import TopupWalletController from './release/pages/topup-wallet/TopupWalletController';
import CustomizedCircularProgress from './release/components/CircularProgress';
import ServiceRequestsController from './release/pages/service-requests/ServiceRequestsController';
import RedeemPassController from './release/pages/redeem-pass/RedeemPassController';
import WalletJournals from './release/pages/wallet-journals/WalletJournals';
import MobilePassCardController from './release/pages/mobile-pass-card/MobilePassCardController';
import MyOrderCards from './release/pages/order-cards/Cards'

var path = custom_assets[domainName] && custom_assets[domainName].customImage && custom_assets[domainName].customImage.logo  ? portalCfg.publicPath + "/custom_assets" : portalCfg.publicPath + "/assets";
const LANGUAGE = 'LANGUAGE';

const styles = theme => ({
	root: {
		display: 'flex',
	},
	first_page:{
		display: 'flex',
	},
	loadingScreen:{
		minHeight: '100vh',
		
	},
	pageContainer: {
		// minHeight: '100vh'
		height: window.innerHeight
	},
	pageBody: {
		flex: 'auto'
	},
	marginTop: {
		// marginTop: theme.spacing.unit2x
	},
	content: {
		flexGrow: 1,
	},
	logo:{
		width: 120,
	},
});

class App extends Component {
	constructor(props) {
		super(props);
		this.state = {
			open: false,
			ready: false,
			showLoading: false,
			error: {
				showAlert: false,
				title: '',
				message: '',
				status: '',
			},
			isLoginEmail: false,
			openOtherDrawer: {},
			config:{},
			num_notification:0,
		};
		this.handleDrawerToggle = this.handleDrawerToggle.bind(this);
		this.onCloseAlert = this.onCloseAlert.bind(this)
		this.onOpenDrawerOther = this.onOpenDrawerOther.bind(this)
		this.handleDrawerOtherToggle = this.handleDrawerOtherToggle.bind(this)
		this.getNumNotification = this.getNumNotification.bind(this)

	}
	async componentWillMount() {
		setGlobalHistory(this.props.history);
		setT(this.props.t);
		await this.setupChannel();
		await this.loadConfig();
		await this.loadConfigV2();
		if(getData()){
			await this.checkOrderFeature(true)
		}
		else{
			await this.checkOrderFeature(false)
		}
		let languageCode = getLanguage(LANGUAGE);
		if (!languageCode || (languageCode !== 'ENG' && languageCode !== 'GR')) {
			clearSession("LANGUAGE");
			saveDataIntoAsyncStore('LANGUAGE', 'ENG');
		} else
			i18n.changeLanguage(languageCode);

		this.getNumNotification();
	}
	async setupChannel() {
		var key = await getData('API_KEY');
		var crmServer = await getData('CRM_SERVER');
		await crmServices.setupChannel({
			storeKVFn: async (key, value) => {
				saveDataIntoAsyncStore(key, value);
			},
			getKVFn: async (key) => {
				return getData(key);
			},
			sessionInvalidCallback: () => {
				logOut(true);
			},
			//apiKey: key ? key : environment == 'prod' ? connection.crmConfig[domainName].crmApiKey_prod : connection.crmConfig[domainName].crmApiKey_uat,
			apiKey: key ? key : document._portalConfig.publicApiKey ? document._portalConfig.publicApiKey : "",
			host: crmServer ? crmServer : connection.crmConfig.defaultCrmServer
		})
	}
	async loadConfig() {
		this.setState({ showLoading: true })
		try {
			 //var result = await crmServices.config.getAppCfg(environment == 'prod' ? connection.crmConfig[domainName].applicationID_prod : connection.crmConfig[domainName].applicationID_uat);
			 var result = await crmServices.config.getAppCfg(document._portalConfig.useCname ? null : document._portalConfig.applicationID, document._portalConfig.cname ? document._portalConfig.cname : window.location.host );
			//console.log('load loadConfig = ', result)
			if (result.code === 'OK') {
				var settings = result.data
				//settings.public_key = '1095383d-f1ad-4943-a94c-8e885503e8dc'
				if (document._portalConfig.useCname  && settings.public_key){
					var crmServer = await getData('CRM_SERVER');
					await crmServices.setupChannel({
						storeKVFn: async (key, value) => {
							saveDataIntoAsyncStore(key, value);
						},
						getKVFn: async (key) => {
							return getData(key);
						},
						sessionInvalidCallback: () => {
							logOut(true);
						},
						apiKey: settings.public_key,
						host: crmServer ? crmServer : connection.crmConfig.defaultCrmServer
					})
				}

				setAppCfg(settings);
				this.setState({ config: settings});
			} else {
				this.showAlert('ERROR', t('GET_CONFIG_FAIL'))
			}
		} catch (error) {
			console.log("loadConfig exeption:", error);
			this.showAlert('ERROR', t('GET_CONFIG_FAIL'))
		}
		this.setState({ showLoading: false})
	}
	async loadConfigV2() {
		try {
			let result  = await crmServices.config.getConfigV2({
				cloundName: document._portalConfig.useCname ? document._portalConfig.cname ? document._portalConfig.cname : window.location.host : null,
				applicationID: document._portalConfig.applicationID,
			})
			if (result.code == 'OK' && result.data) {
				setPortalConfigV2(result.data)
			}
		} catch (error) {
			console.log("AAAA loadConfigV2 error: ", error)
		}
	}
	async getNumNotification() {
		var result = await crmServices.communications.getUnreadCommunications();
        //console.log('onLoadNotification result====',result)
        if (result.code === 'OK' && result.data && result.data.paging && result.data.paging.total) {

            this.setState({ num_notification: result.data.paging.total })
        }
	}
	async checkOrderFeature(isLogged) {
        var config = getAppCfg();
        if (config && config.features && config.features.ordering) {
			this.checkSupportOrderWithContact(isLogged)
			//this.locationCheckTimer = setInterval(() => this.getLocation(isLogged), 500);
        } else {
            setSupportOrderLocation(false);
            setSupportOrderContact(false);
			this.setState({ready: true})
        }
	}
	async getLocation(isLogged) {
		//console.log('this.state.currentLocation=== ',this.state.currentLocation)
	   if (this.state.currentLocation) {
		   var country_code = await this.getCurrentCountry(this.state.currentLocation);
		   this.stopCheckingLocation();
		   this.checkSupportOrderWithLocation(country_code)
		   return;
	   }
	   else {
		   await navigator.geolocation.getCurrentPosition((location) => {
			   var currentLocation = {
				   lat: location.coords.latitude,
				   lon: location.coords.longitude,
			   }
			   this.setState({ currentLocation: currentLocation });
			   
		   }, (err) => {
			   console.log('getLocation err', err)
			   this.setState({ showLoading: false });
			   this.stopCheckingLocation();
			   this.checkSupportOrderWithContact(isLogged)
		   }, {
			   timeout: 5000,
			   enableHighAccuracy: false
		   });
	   }
   }
	handleDrawerToggle() {
		this.setState({ open: !this.state.open })
	}
	showAlert(status, message, title) {
		this.setState({
			showLoading: false,
			error: {
				showAlert: true,
				title: title,
				message: message,
				status: status,
			}
		})
	}
	onCloseAlert() {
		this.setState({
			showLoading: false,
			error: {
				showAlert: false,
				title: '',
				message: '',
				status: '',
			}
		})
	}
	onOpenDrawerOther(target) {
		//console.log('onOpenDrawerOther target= ',target)
		
		var openOtherDrawer = { ...this.state.openOtherDrawer }
		openOtherDrawer[target] = true
		this.setState({ openOtherDrawer: openOtherDrawer })
	}
	handleDrawerOtherToggle(target) {
		var openOtherDrawer = { ...this.state.openOtherDrawer }
		openOtherDrawer[target] = false
		this.setState({ openOtherDrawer: openOtherDrawer })
	}
    stopCheckingLocation() {
        if (this.locationCheckTimer) {
            clearInterval(this.locationCheckTimer);
        }
    }
    
	async getCurrentCountry(currentLocation){
		 //console.log(' getLocationInfo=======',currentLocation)
		var json = await Geocode.fromLatLng(currentLocation.lat, currentLocation.lon, portal_config.apiKey, "en");
		var result = json.results[0];
		//console.log('result==== ',result)
		var country_code = null
		try {
			var address_component = result.address_components;
			if (address_component && address_component.length > 0) {
				address_component.forEach(element => {
					if (element.types.length > 0) {
						if (element.types[0] === 'country') {
						   // console.log('country=== ',element.short_name )
							country_code = element.short_name;
						   //
						}
					}
				});
			}
		} catch (error) {
			console.log("set address info exception:", error);
		}
		//console.log(' country_code========',country_code)
		if(country_code==='CY'){
		   country_code ='CYP'
		}
		return country_code
	 }
	 checkSupportOrderWithLocation(country_code){
		var config = getAppCfg()
		var ordering_countries = []
		var isAllowOrder = false
		if(config.features&&config.features.ordering_details&&config.features.ordering_details.ordering_countries){
		   ordering_countries = config.features.ordering_details.ordering_countries
		}
		//console.log('checkSupportOrderWithLocation====country_code=',country_code)
		//console.log('checkSupportOrderWithLocation====ordering_countries=',ordering_countries)
		ordering_countries.forEach(item=>{
			if(item.country===country_code){
				isAllowOrder = true
			}
		})
		setSupportOrderLocation(isAllowOrder);
		setRejectTriggerContact(!isAllowOrder);
		this.setState({ready: true})
	 }
	 async checkSupportOrderWithContact(isLogged){
		var config = getAppCfg()
		var ordering_countries = []
		
		if(config.features&&config.features.ordering_details&&config.features.ordering_details.ordering_countries){
		   ordering_countries = config.features.ordering_details.ordering_countries
		}
		if(isLogged){
			var isAllow = await dataUtil.checkAllowOrderByContact(ordering_countries)
			setSupportOrderContact(isAllow);
			setSupportOrderLocation(false);
		}
		else{
			setSupportOrderContact(false);
			setSupportOrderLocation(false);
		}
		this.setState({ready: true})
	 }
	getTheme(){
		var config = this.state.config;
		var initTheme = defaultTheme;
		if(config && config.appearance && !portal_config[domainName].usingLocalTheme){
			if(config.appearance.button_color){
				initTheme.palette.button.primary.backgroundColor = config.appearance.button_color;
				initTheme.palette.button.primary.borderColor = config.appearance.button_color;
				initTheme.palette.button.secondary.borderColor = config.appearance.button_color;
				initTheme.palette.button.secondary.color = config.appearance.button_color;
				if(portal_config[domainName].publicPagePrimaryColor){
					initTheme.palette.button.light.color = config.appearance.button_color;
				}
			}
			if(config.appearance.background_color ){ 
				initTheme.palette.primary.main = config.appearance.background_color;
				initTheme.palette.background.tertiary = config.appearance.background_color;
				initTheme.palette.secondary.main = config.appearance.background_color;
				initTheme.palette.text.tabSelected = "#ffffff"
				initTheme.palette.text.secondary = config.appearance.card_color;

				if(portal_config[domainName].publicPagePrimaryColor){
					initTheme.palette.background.box = config.appearance.background_color;
					initTheme.palette.background.switch = "#ffffff"
					initTheme.palette.background.first_page = config.appearance.background_color;
					initTheme.palette.button.dark.backgroundColor = config.appearance.card_color;
					initTheme.palette.button.dark.borderColor = config.appearance.card_color;
				}
				else{
					initTheme.palette.background.switch = config.appearance.button_color ? config.appearance.button_color : config.appearance.card_color;//ipharm
				}

				if(!portal_config[domainName].mainPageLocalColor)
					initTheme.palette.background.main = config.appearance.background_color;//ipharm

				initTheme.palette.text.link = config.appearance.background_color;//ipharm
				

				if(!portal_config[domainName].textPriLocalColor)//ipharm
					initTheme.palette.text.primary = config.appearance.background_color;
			}
			if(config.appearance.card_color){
				initTheme.palette.background.card = config.appearance.card_color;
				initTheme.palette.background.primary = config.appearance.card_color;
				if(!portal_config[domainName].headerLocalColor)
					initTheme.palette.background.header = config.appearance.card_color;//ipharm
				if(!portal_config[domainName].drawerLocalColor){
					initTheme.palette.background.drawer = config.appearance.card_color;
				}
			}
		}else{
			if(custom_theme.theme){
				initTheme = custom_theme.theme
			} 
		}
		//console.log("AAAAAAAAA defaultTheme:",initTheme);
		var theme = createTheme(initTheme);
		console.log("AAAAAAAAA theme:",theme);
		return theme;
	}
	createImage(className) {
        if (portal_config[domainName].localLogo) {
            return <img src={isRetina(path + "/images/logo.png", path + "/images/logo@2x.png")} className={className} style={portal_config[domainName].logoDimension ? {...portal_config[domainName].logoDimension} : undefined}/>
        } else {
            var app_config = getAppCfg();
            var srcset = ""
            var logoUrl = ""
            if (app_config && app_config.creatives && app_config.creatives.length > 0) {
                var media = app_config.creatives[0].media;
                if (media && media.length > 0) {
                    var srcset = ""
                    media.forEach((element, index) => {
                        srcset = srcset + element.url + " " + (index + 1) + "x,";
                    });
                    if (srcset)
                        srcset = srcset.substr(0, srcset.length - 1);
                }
				let business_logo = dataUtil.getImageByUsageTypePortal(app_config.creatives, usage_type.APP_LOGO, true);
				if(business_logo){
					logoUrl = business_logo ? business_logo : null;
				}else{
					//var path = custom_assets[domainName] && custom_assets[domainName].customImage.logo  ? portalCfg.publicPath + "/custom_assets" : portalCfg.publicPath + "/assets";
					logoUrl = path+ "/images/logo.png";
				}
            }
            if (srcset) {
                return <img src={logoUrl.url ? logoUrl.url : logoUrl} className={className}/>
            } else if (logoUrl) {
                return <img src={logoUrl.url ? logoUrl.url : logoUrl} className={className}/>
            } else {
                return <CircularProgress color={'secondary'}/>
            }
        }
    }
	render() {
		const { classes } = this.props;
		var token = getData();
		const theme = this.getTheme();
		if (this.state.ready) {
			return (
				<MuiThemeProvider theme={theme}>
					<div className={classes.root}>
						{(token) && <Header handleDrawerToggle={this.handleDrawerToggle} onOpenDrawerOther={this.onOpenDrawerOther} num_notification={this.state.num_notification}/>}
						{/* {token && <MenuDrawer open={this.state.open}  handleDrawerToggle={this.handleDrawerToggle} onOpenDrawerOther = {this.onOpenDrawerOther}/>} */}
						{this.state.openOtherDrawer.transactions&&<Transactions open={this.state.openOtherDrawer.transactions} handleDrawerOtherToggle={this.handleDrawerOtherToggle} />}
						{this.state.openOtherDrawer.refer_friend&&<ReferFriend open={this.state.openOtherDrawer.refer_friend} handleDrawerOtherToggle={this.handleDrawerOtherToggle} />}
						{this.state.openOtherDrawer.my_profile&&<MyProfile open={this.state.openOtherDrawer.my_profile} handleDrawerOtherToggle={this.handleDrawerOtherToggle} />}
						{this.state.openOtherDrawer.more_info&&<MoreInfo open={this.state.openOtherDrawer.more_info} handleDrawerOtherToggle={this.handleDrawerOtherToggle} />}
						{this.state.openOtherDrawer.my_account&&<MyAccount open={this.state.openOtherDrawer.my_account} handleDrawerOtherToggle={this.handleDrawerOtherToggle} />}
						{this.state.openOtherDrawer.notifications&&<Notifications open={this.state.openOtherDrawer.notifications} onClose={this.handleDrawerOtherToggle} refreshNotificationForHeader={this.getNumNotification}/>}
						{this.state.openOtherDrawer.order_history&&<OrderHistoryController open={this.state.openOtherDrawer.order_history} onClose={()=>this.handleDrawerOtherToggle('order_history')} />}
						{this.state.openOtherDrawer.setting&&<SettingsController open={this.state.openOtherDrawer.setting} onClose={()=>this.handleDrawerOtherToggle('setting')} />}
						{this.state.openOtherDrawer.address_book&&<Addresses open={this.state.openOtherDrawer.address_book} onCloseItem={()=>this.handleDrawerOtherToggle('address_book')} />}
						{this.state.openOtherDrawer.topup_wallet&&<TopupWalletController open={this.state.openOtherDrawer.topup_wallet} onClose={()=>this.handleDrawerOtherToggle('topup_wallet')} />}
						{this.state.openOtherDrawer.service_requests&&<ServiceRequestsController open={this.state.openOtherDrawer.service_requests} onClose={()=>this.handleDrawerOtherToggle('service_requests')} />}
						{this.state.openOtherDrawer.redeem_pass&&<RedeemPassController open={this.state.openOtherDrawer.redeem_pass} onClose={()=>this.handleDrawerOtherToggle('redeem_pass')} />}
						{this.state.openOtherDrawer.wallet_journals && <WalletJournals open={this.state.openOtherDrawer.wallet_journals} onClose={()=>this.handleDrawerOtherToggle('wallet_journals')} />}
						{this.state.openOtherDrawer.mobile_pass_card && <MobilePassCardController open={this.state.openOtherDrawer.mobile_pass_card} onClose={()=>this.handleDrawerOtherToggle('mobile_pass_card')} />}
						{this.state.openOtherDrawer.my_cards && <MyOrderCards open={this.state.openOtherDrawer.my_cards} onCloseItem={()=>this.handleDrawerOtherToggle('my_cards')} />}
						<main className={classes.content}>
							<Routers rootProps={{ handleDrawerToggle: this.handleDrawerToggle }} config={this.state.config} />
						</main>
						<ModalAlert
							open={this.state.error.showAlert}
							onClose={this.onCloseAlert}
							hideHeader={true}
							message={this.state.error.message}
							error={this.state.error.status}
							title={this.state.error.title}
						/>
						{this.state.showLoading && <Loading showLoading={this.state.showLoading} />}
					</div>
				</MuiThemeProvider>

			);
		} else {
			return (
				<MuiThemeProvider theme={theme}>
					<div className={classes.first_page} style={{backgroundColor: (portal_config[domainName].splashColor?portal_config[domainName].splashColor: theme.palette.background.first_page)}}>
						<Grid xs={12} item container justify='center' alignItems='center' className={classes.loadingScreen}>
							{this.createImage(classes.logo)}
						</Grid>
					</div>
				</MuiThemeProvider>
			)
		}
	}
}

export default withRouter(withStyles(styles)(withTranslation()(App)))
